// Per–knowledge-system (tradition) colours for the Timeline ribbon.
// Drawn from the Living Wisdom Explorer earthy manuscript palette, kept distinguishable.
export const TRADITION_COLORS = {
  ks_vedanta: "#ff7360",
  ks_mimamsa: "#8a6d3b",
  ks_nyaya: "#10a37f",
  ks_vaisheshika: "#a8564a",
  ks_samkhya: "#7c3aed",
  ks_yoga: "#5b7b8a",
  ks_buddhism: "#ffb020",
  ks_jainism: "#6b8e4e",
  ks_carvaka: "#9c6b3f",
  ks_shaivism: "#4e6073",
  ks_vaishnavism: "#b3843a",
  ks_shaktism: "#a0466b",
  ks_sant: "#06b6d4",
  ks_sikh: "#3f7a6b",
};

export const NEUTRAL_TRADITION = "#9a917f";

export const traditionColor = (ksId) => TRADITION_COLORS[ksId] || NEUTRAL_TRADITION;
